/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Rpc from 'fierry/flux/entity/rpc';
import DynamicElement from 'fierry/rpc.old/dynamic-element';

import Session from 'astro/rpc/session';
import RootModel from 'astro/server/root';

import * as Translator from 'astro/rpc/translator';


export default new Rpc('galax', class extends DynamicElement
{
  constructor ()
  {
    super(RootModel);

    this.createElement('galaxy', new Session());

    this.createRecord('currentTime', [ Translator.CurrentTime ]);
  }
});
